/**
 * Decodes and parses a base64-encoded JSON string into a TypeScript object.
 *
 * @template T - The expected type of the parsed object
 * @param {string} base64URI - The base64-encoded string to parse. Can optionally include
 *                            the 'data:application/json;base64,' prefix
 * @returns {T | null} The parsed object of type T, or null if parsing fails
 *
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseBase64<T = any>(base64URI: string): T | null {
  try {
    // Standard prefix for base64-encoded JSON data URIs
    const base64Prefix = 'data:application/json;base64,';

    // Remove the prefix if it exists
    const formattedBase64URI = base64URI.startsWith(base64Prefix)
      ? base64URI.slice(base64Prefix.length)
      : base64URI;

    // Decode the base64 string to a UTF-8 string
    const json = Buffer.from(formattedBase64URI, 'base64').toString('utf-8');

    // Parse the JSON string into an object and cast to type T
    return JSON.parse(json) as T;
  } catch (error) {
    // Log any errors that occur during decoding or parsing
    console.error('Error parsing base64 JSON data:', error);
    return null;
  }
}
